import { getUrlWithSchema } from "@shared/common/utils/url";
import type { ExternalSiteRule } from "../../types";
import { CAFE24_PAGE, SITE_TYPE } from "./const";

const cafe24: ExternalSiteRule = {
  type: SITE_TYPE,

  getInfo: async ({ html, responseUrl }) => {
    if (!html.innerHTML.includes("window.CAFE24")) {
      return "INVALID";
    }

    // TODO: 추후 카페24를 통한 자동연동 링크 제공을 위해 mallId와 shopNo를 찾아서 반환하는 로직 추가
    return {
      siteType: SITE_TYPE,
      url: responseUrl,
      siteInfo: {
        type: SITE_TYPE,
      },
    };
  },

  pageRules: [
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.LOGIN.target,
      label: "로그인",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.LOGIN.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.SIGNUP.target,
      label: "가입하기",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.SIGNUP.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.SIGNUP_COMPLETE.target,
      label: "가입하기 완료",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.SIGNUP_COMPLETE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.ORDER_SUCCESS.target,
      label: "구매 완료",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.ORDER_SUCCESS.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.MY_PAGE.target,
      label: "마이페이지",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.MY_PAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.CART.target,
      label: "장바구니",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.CART.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.GUIDE.target,
      label: "이용안내",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.GUIDE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.FIND_ID.target,
      label: "아이디 찾기",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.FIND_ID.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.FIND_PASSWORD.target,
      label: "비밀번호 찾기",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.FIND_PASSWORD.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.MEMBER_MODIFY.target,
      label: "회원정보 수정",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.MEMBER_MODIFY.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.CHECK_ORDER.target,
      label: "주문 내역 조회",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.CHECK_ORDER.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.WISH_LIST.target,
      label: "관심상품",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.WISH_LIST.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.CHECK_MILEAGE.target,
      label: "적립 내역 조회",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.CHECK_MILEAGE.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.COUPON.target,
      label: "쿠폰",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.COUPON.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.BOARD_LIST.target,
      label: "게시물 관리",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.BOARD_LIST.url}`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.DELIVERY_ADDR_LIST.target,
      label: "배송지 관리",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          CAFE24_PAGE.DELIVERY_ADDR_LIST.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.REGULAR_DELIVERY_LIST.target,
      label: "정기배송 관리",
      getExactUrl({ siteUrl }) {
        return `${getUrlWithSchema(siteUrl)}${
          CAFE24_PAGE.REGULAR_DELIVERY_LIST.url
        }`;
      },
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.CATEGORY.target,
      label: "상품별 카테고리",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.CATEGORY.url}/${
            params.productSlug
          }`;
        }
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.CATEGORY.url}/...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
    {
      siteType: SITE_TYPE,
      targetValue: CAFE24_PAGE.PRODUCT.target,
      label: "상품상세",
      getExactUrl({ siteUrl, params }) {
        if (params?.productSlug) {
          return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.PRODUCT.url}/${
            params.productSlug
          }`;
        }
        return `${getUrlWithSchema(siteUrl)}${CAFE24_PAGE.PRODUCT.url}/...`;
      },
      allowDuplicate: true,
      params: [
        {
          key: "productSlug",
          formType: "TEXT",
          placeholder: "/하위경로를 입력해주세요",
        },
      ],
    },
  ],
};

export default cafe24;
